export function sum(a: readonly number[]): number;
export function sum<T>(a: readonly T[], fn: (e: T) => number): number;
export function sum<T>(a: readonly T[], fn?: (e: T) => number): number {
	return Math.sumPrecise(fn ? a.values().map(fn) : (a as readonly number[]).values());
}
